<template>
  <tbody class="pumpOverview-row" :class="[{ 'is-expanded': isExpanded }]">
    <tr
      ref="row"
      :class="{ 'cursor-pointer': true, 'bg-sky-100': isPumpHover }"
      @click="
        toggle();
        $emit('selectPump', {
          isPumpSelected: pumpSelected,
          pumpId: currentPumpId,
          productId: currentProductId,
          serialNumber: currentSerialNumber
        });
      "
      @mouseenter="getContentCss"
      @mouseleave="getContentCss"
    >
      <td v-if="pumpAssignmentPage" class="pumpOverview-row__cell">
        <div v-if="data.equipmentID" class="form-group__radio pumpOverview-row__cell__rdb">
          <input :id="'rdb' + data.equipmentID" name="rdbPump" type="radio" />
          <label :for="'rdb' + data.equipmentID"><span /></label>
        </div>
        <div v-else class="form-group__radio pumpOverview-row__cell__rdb">
          <input :id="'rdb' + data.pumpDesc.split('-')[0]" name="rdbPump" type="radio" />
          <label :for="'rdb' + data.pumpDesc.split('-')[0]"><span /></label>
        </div>
      </td>
      <td class="pumpOverview-row__cell">
        <ul class="pumpOverview-row__cell__desc">
          <li>
            <img :src="data.imageURL" class="pumpOverview-row__cell__img" @error="imageLoadError" />
          </li>
        </ul>
      </td>
      <td class="pumpOverview-row__cell">
        <ul v-if="pumpAssignmentPage" class="pumpOverview-row__cell__desc">
          <li>{{ computedPumpDesc }}</li>
        </ul>
        <ul v-else class="pumpOverview-row__cell__desc">
          <li>
            {{ data.pumpDesc }}
          </li>
        </ul>
      </td>
      <td class="pumpOverview-row__cell">
        <ul class="pumpOverview-row__cell__serialno">
          <li v-if="data.equipmentStatus === 'Onbekend'">
            <v-input-group-simple-2
              id="Serienummer"
              v-model:value="currentSerialNumber"
              :rules="{
                required: true
              }"
              type="text"
              placeholder="Serienummer*"
              class="pumpOverview-row__cell__textbox"
              @input="$emit('setSerialNumber', { serialNumber: currentSerialNumber })"
            />
          </li>
          <li v-else-if="data.equipmentStatus === 'Mediq'" />
          <li v-else>
            {{ data.serialNo }}
          </li>
        </ul>
      </td>
      <td class="pumpOverview-row__cell" v-if="overviewPage">
        <ul class="pumpOverview-row__cell__dynamicField">
          <li>
            <div :class="getStatusColor(data.equipmentStatus)">
              <v-circle-icon class="pumpOverview-row__cell__dynamicField__circle_class" />
              <span>{{ getStatusField(data.equipmentStatus) }}</span>
            </div>
          </li>
        </ul>
      </td>
      <td class="pumpOverview-row__cell">
        <ul class="pumpOverview-row__cell__dynamicField">
          <li>
            <div :class="getStatusColorForDaysLeftForMaintenance(data.daysLeftForMaintenance)">
              <component :is="'VCircleIcon'" class="pumpOverview-row__cell__dynamicField__circle_class" />
              <span v-if="data.equipmentStatus === 'Naar Mediq' && data.returnType === 'RETOUR'">
                Afleveren bij PostNL
              </span>
              <span v-else-if="data.plannedMaintanceRequestDate">
                Ophalen gepland op {{ $formatDate(data.plannedMaintanceRequestDate) }}
              </span>
              <span v-else-if="data.daysLeftForMaintenance == null">Onbekend</span>
              <span v-else>{{ data.daysLeftForMaintenance + ' dagen' }}</span>
            </div>
          </li>
        </ul>
      </td>
      <td class="pumpOverview-row__cell justify-content-end" v-if="!pumpAssignmentPage">
        <div class="grid mx-auto mt-4 md:mt-0">
          <button
            v-if="isExpanded"
            @click.stop="
              toggle();
              $emit('selectPump', {
                isPumpSelected: pumpSelected,
                pumpId: currentPumpId,
                productId: currentProductId,
                serialNumber: currentSerialNumber
              });
            "
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full ml-auto text-nowrap"
          >
            <span>Toon minder</span>
          </button>

          <button
            v-else
            @click.stop="toggle()"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full ml-auto text-nowrap"
          >
            <span>Toon meer</span>
          </button>
        </div>
      </td>
    </tr>
    <tr v-show="data.equipmentStatus === 'Naar Mediq' && data.returnType === 'RETOUR' && isExpanded">
      <td colspan="7">
        <Alert
          :html="true"
          htmlMessage="“Lever je pakket af bij een PostNL punt met adres: Mediq Bleiswijk t.a.v. Afdeling Decontaminatie / Antwoordnummer 12310 / 2665 ZZ Bleiswijk."
          type="info"
          class="z-40 p-0 mx-4 mb-4"
        ></Alert>
      </td>
    </tr>
    <tr v-show="isExpanded">
      <td class="pumpOverview-row__cell" colspan="4">
        <div v-show="!data.returnType && data.returnType !== 'RETOUR' && data.equipmentStatus !== 'Naar Mediq'">
          <div v-if="overviewPage && (data.equipmentStatus === 'Lend' || data.equipmentStatus === 'LendAndAssigned')">
            <p ref="prescriber" class="pumpOverview-row__cell__prescriber">
              Uitgeleend op
              <b>
                {{ $formatDate(data.lendoutDate) }} aan {{ data.lendoutWarehouseName }} -
                {{ data.lendoutWarehouseId }}
              </b>
            </p>
            <p
              v-if="userWarehouseId !== data.lendoutWarehouseId"
              ref="prescriber"
              class="pumpOverview-row__cell__prescriber"
            >
              Verantwoordelijk voor ophalen: <b>Uw organisatie</b>
            </p>
            <p v-else ref="prescriber" class="pumpOverview-row__cell__prescriber">
              Verantwoordelijk voor ophalen: <b>{{ data.lendoutWarehouseDepartment }}</b>
            </p>
          </div>
          <div v-else-if="overviewPage && data.equipmentStatus === 'OutOfDepot'">
            <p ref="prescriber" class="pumpOverview-row__cell__prescriber">
              {{ data.prescriberName }} heeft de pomp op {{ data.pumpUseReasonDate }} ingezet voor:
              {{ data.pumpUseReason }}
            </p>
          </div>
          <div v-else-if="overviewPage">
            <p ref="prescriber" class="pumpOverview-row__cell__prescriber">
              Toegewezen door <b>{{ data.prescriberName }}.</b>
            </p>
            <p ref="prescriber" class="pumpOverview-row__cell__prescriber">
              Verantwoordelijk voor ophalen:
              <b><span v-if="data.equipmentType === 'RCC'">Uw organisatie</span><span v-else>Mediq</span></b>
            </p>
          </div>
          <div v-else>
            <p ref="prescriber" class="pumpOverview-row__cell__prescriber">
              Na gebruik wordt deze pomp opgehaald door
              <span v-if="data.equipmentType === 'RCC'"> Uw organisatie </span>
              <span v-else> Mediq </span>.
            </p>
            <p ref="prescriber" class="pumpOverview-row__cell__prescriber">
              Pomp toegewezen door <span class="pump-row__cell__prescriber__author">{{ data.prescriberName }}</span> op
              <span class="pump-row__cell__prescriber__author">{{ $formatDate(data.dateOfAllocation) }}</span>
            </p>
          </div>
        </div>
        <div class="flex flex-row gap-2 mt-4">
          <button
            v-show="
              overviewPage &&
              data.equipmentStatus !== 'Available' &&
              data.equipmentStatus !== 'Lend' &&
              data.equipmentStatus !== 'LendAndAssigned' &&
              data.equipmentStatus !== 'ToMediq' &&
              data.equipmentStatus !== 'Naar Mediq' &&
              data.equipmentStatus !== 'OutOfDepot'
            "
            @click="toPatientDashboard"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-primary-color items-center bg-white border border-primary-color rounded-full text-nowrap"
          >
            <UserIcon class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block mr-2" aria-hidden="true" />
            Naar Patient
          </button>
          <button
            v-show="
              overviewPage &&
              data.equipmentStatus !== 'Lend' &&
              data.equipmentStatus !== 'LendAndAssigned' &&
              data.equipmentStatus !== 'ToMediq' &&
              data.equipmentStatus !== 'Naar Mediq' &&
              data.equipmentStatus !== 'OutOfDepot'
            "
            @click="
              $emit('retrieve', { id: data.equipmentID });
              toggle();
            "
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            <v-truck-delivery-icon class="h-4 w-4 mr-2" />
            Reparatie aanvragen
          </button>
          <button
            v-show="
              overviewPage &&
              data.equipmentStatus !== 'Lend' &&
              data.equipmentStatus !== 'LendAndAssigned' &&
              data.equipmentStatus !== 'ToMediq' &&
              data.equipmentStatus !== 'Naar Mediq' &&
              data.equipmentStatus !== 'OutOfDepot'
            "
            @click.prevent="pumpLending"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            <img src="@/static/img/icons/arrow-top-right-thin-circle-outline.png" class="h-6 w-6 mr-2" />
            Uitlenen
          </button>
          <button
            v-show="
              overviewPage &&
              data.equipmentStatus === 'Lend' &&
              data.equipmentStatus !== 'LendAndAssigned' &&
              userWarehouseId !== data.lendoutWarehouseId &&
              data.equipmentStatus !== 'OutOfDepot'
            "
            @click="showPumpReturnPopup"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            <v-clipboard-arrow-left class="h-4 w-4 mr-2" />
            Retour nemen
          </button>
          <button
            v-show="
              overviewPage &&
              data.equipmentStatus === 'Available' &&
              data.equipmentStatus !== 'LendAndAssigned' &&
              data.equipmentStatus !== 'ToMediq' &&
              data.equipmentStatus !== 'Naar Mediq' &&
              data.equipmentStatus !== 'OutOfDepot'
            "
            @click.prevent="$router.push('/')"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            <UserPlusIcon class="h-3 md:h-5 lg:h-5 w-3 md:w-5 lg:w-5 inline-block mr-2" aria-hidden="true" />
            Koppel aan patiënt
          </button>
          <button
            v-show="overviewPage && isPumpLeftDepot && data.equipmentStatus !== 'OutOfDepot'"
            @click.prevent="setPumpLeftDepotPopup"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-primary-color items-center bg-white border border-primary-color rounded-full text-nowrap"
          >
            Anders inzetten
          </button>
          <button
            v-show="overviewPage && data.equipmentStatus === 'OutOfDepot'"
            @click.prevent="updatePumpStatus(data.equipmentID, 'Available')"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap mr-2"
          >
            Pomp inzetten
          </button>
        </div>
      </td>
      <td class="pumpOverview-row__cell" />
    </tr>
    <v-overlay v-if="isPumpLending">
      <div class="pumpOverviewLending">
        <div class="flex flex-col relative mb-4">
          <div class="text-xl text-pdsPrimaryColor">Pomp uitlenen</div>
          <div class="absolute top-0 right-0">
            <XMarkIcon
              class="h-6 w-6 text-pdsPrimaryColor cursor-pointer"
              aria-hidden="true"
              @click.prevent="closeModal()"
            />
          </div>
        </div>
        <div class="grid grid-rows gap-4">
          <div class="text-base font-bold text-tdefault-color">
            Selecteer hieronder het depot aan wie u de pomp wilt uitlenen.
          </div>
          <div class="relative">
            <v-input-group
              v-model="lendingPostalCode"
              :rule="postCodeRule"
              inputid="Naam of postcode"
              placeholder="Zoek op naam of postcode (1234 AA) van het depot"
            />
            <MagnifyingGlassIcon
              class="h-6 w-6 text-pdsPrimaryColor absolute right-2 top-3 cursor-pointer"
              aria-hidden="true"
              @click.prevent="getWarehouseListData()"
            />
          </div>
          <div class="pumpOverviewLending__selectDept" v-show="warehouses.length > 0">
            <v-select-group
              v-model="currentWarehouseId"
              :overwrite-value="currentWarehouseId"
              selectid="WarehouseId"
              :initselected="'0'"
              @change.prevent="selectWarehouse($event)"
            >
              <option v-if="warehouses.length > 1" value="0">Selecteer depot</option>
              <option
                v-for="(item, index) in warehouses"
                :key="index + 1"
                :data-index="index + 1"
                :value="item.warehouseId"
              >
                {{ item.warehouseName }} - {{ item.postalCode }} - {{ item.warehouseId }}
              </option>
            </v-select-group>
            <v-warning-message
              v-show="showWarning"
              warning="Helaas is er geen depot gevonden met bovenstaand postcode."
              message="Probeer het nogmaals."
              :show-close="false"
            />
          </div>
        </div>
        <div class="flex flex-row justify-end gap-4 mt-4">
          <a
            class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
            @click.prevent="closeModal()"
          >
            Annuleren
          </a>
          <button
            @click.prevent="lendoutPump(data.equipmentID)"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
            :class="{ 'bg-slate-400 border-slate-400': currentWarehouseId === '0' || currentWarehouseId === '' }"
            :disabled="currentWarehouseId === '0' || currentWarehouseId === ''"
          >
            Versturen
          </button>
        </div>
      </div>
    </v-overlay>
    <v-overlay v-if="pumpLendingSuccess">
      <div class="pumpOverviewLending">
        <div class="flex flex-col relative mb-4">
          <div class="text-xl text-pdsPrimaryColor">Pomp overgedragen</div>
          <div class="absolute top-0 right-0">
            <XMarkIcon
              class="h-6 w-6 text-pdsPrimaryColor cursor-pointer"
              aria-hidden="true"
              @click.prevent="closeSucessModal()"
            />
          </div>
        </div>
        <div class="grid grid-rows gap-4">
          <div class="justify-items-center">
            <CheckCircleIcon
              class="h-10 w-10 text-success-default"
              aria-hidden="true"
              @click.prevent="closeSucessModal()"
            />
          </div>
          <div class="text-base font-bold text-tdefault-color text-center">Pomp is succesvol overgedragen!</div>
          <div class="mx-auto rounded-full border border-primary-default shadow-2xl">
            <img src="@/static/img/succes_mascot.png" class="w-32" />
          </div>
        </div>
        <div class="flex flex-row justify-center gap-4 mt-4">
          <button
            @click.prevent="closeSucessModal"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            Ga verder
          </button>
        </div>
      </div>
    </v-overlay>
    <v-overlay v-if="isPumpReturn">
      <div class="pumpOverviewLending">
        <div class="flex flex-col relative mb-4">
          <div class="text-xl text-pdsPrimaryColor">Pomp retour nemen</div>
          <div class="absolute top-0 right-0">
            <XMarkIcon
              class="h-6 w-6 text-pdsPrimaryColor cursor-pointer"
              aria-hidden="true"
              @click.prevent="closeModal()"
            />
          </div>
        </div>
        <div class="grid grid-rows gap-4">
          <div class="text-base font-bold text-tdefault-color">
            U staat op het punt om deze pomp retour te nemen na uitleen. Weet u zeker dat u wilt doorgaan?
          </div>
        </div>
        <div class="flex flex-row justify-end gap-4 mt-4">
          <a
            class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
            @click.prevent="closeModal()"
          >
            Annuleren
          </a>
          <button
            @click.prevent="pumpReturn(data.equipmentID)"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            Neem pomp retour
          </button>
        </div>
      </div>
    </v-overlay>
    <v-overlay v-show="showPumpLeftDepotPopup">
      <div class="pumpOverviewLending">
        <div class="flex flex-col relative mb-4">
          <div class="text-xl text-pdsPrimaryColor">Pomp anders inzetten</div>
          <div class="absolute top-0 right-0">
            <XMarkIcon
              class="h-6 w-6 text-pdsPrimaryColor cursor-pointer"
              aria-hidden="true"
              @click.prevent="closeModal()"
            />
          </div>
        </div>
        <div class="grid grid-rows gap-4">
          <div class="text-slate-600 font-bold">
            <div class="mb-2">Vul in hoe de pomp is ingezet</div>
            <textarea
              id="pumpUseReason"
              class="border border-bdefault shadow rounded-lg p-4 min-h-20 outline-none w-full"
              @input="setPumpUseReason($event.target.value)"
            />
          </div>
        </div>
        <div class="flex flex-row justify-end gap-4 mt-4">
          <a
            class="text-pdsPrimaryColor font-bold mt-2 cursor-pointer text-xs md:text-base"
            @click.prevent="closeModal()"
          >
            Annuleren
          </a>
          <button
            @click.prevent="savePumpUseReason(data.equipmentID)"
            class="flex justify-center p-2 md:px-4 text-xs md:text-base font-medium text-white items-center bg-primary-default border border-primary-default rounded-full text-nowrap"
          >
            Opslaan
          </button>
        </div>
      </div>
    </v-overlay>
  </tbody>
</template>

<script>
import { mapActions, mapMutations, useStore } from 'vuex';
import { ref, computed, getCurrentInstance } from 'vue';
import router from '@/router';
import VTruckDeliveryIcon from 'icons/TruckDelivery';
import VCircleIcon from 'icons/Circle';
import VOverlay from '@/components/shared/Overlay.vue';
import VWarningMessage from '@/components/shared/WarningMessage';
import VClipboardArrowLeft from 'icons/ClipboardArrowLeft';
import { UserPlusIcon, XMarkIcon, UserIcon, MagnifyingGlassIcon, CheckCircleIcon } from '@heroicons/vue/20/solid';
import { useForm } from 'vee-validate';
import axios from 'axios';

export default {
  name: 'PumpOverviewRow',
  components: {
    XMarkIcon,
    VTruckDeliveryIcon,
    VCircleIcon,
    VOverlay,
    VWarningMessage,
    VClipboardArrowLeft,
    UserPlusIcon,
    UserIcon,
    MagnifyingGlassIcon,
    CheckCircleIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    userWarehouseId: {
      type: String,
      default: ''
    }
  },
  emits: ['forceResetFilters'],
  setup(props, { emit }) {
    const inst = getCurrentInstance();
    const store = useStore();
    const showPumpLeftDepotPopup = ref(false);
    const pumpUseReason = ref(null);

    const isPumpLeftDepot = computed(() => {
      if (!props.data) return false;

      return (
        props.data.equipmentStatus === 'Available' &&
        (!props.data.trackerLocation || props.data.trackerLocation.trim() === '')
      );
    });
    const warehouses = computed(() => store.getters['pumpOverview/getWarehouses']);
    const currentWarehouseId = computed(() => store.getters['pumpOverview/getCurrentWarehouseId']);
    const showWarning = computed(() => store.getters['pumpOverview/getShowWarning']);
    const pumpLendingSuccess = computed(() => store.getters['pumpOverview/getPumpLendingSuccess']);
    const isPumpReturn = computed(() => store.getters['pumpOverview/getIsPumpReturn']);

    const setPumpLeftDepotPopup = () => {
      showPumpLeftDepotPopup.value = true;
    };

    const setPumpUseReason = (reason) => {
      pumpUseReason.value = reason;
    };

    const savePumpUseReason = async (equipmentId) => {
      const requestData = {
        equipmentId: equipmentId,
        reason: pumpUseReason.value
      };

      await axios.post('equipment/UpdatePumpUseReason', requestData).then((response) => {
        if (response && response.data && response.data.Success) {
          showPumpLeftDepotPopup.value = false;
          emit('forceResetFilters');
          inst.proxy.setExpantFlag(false);
        }
      });
    };

    const updatePumpStatus = async (equipmentId, pumpStatus) => {
      const requestData = {
        equipmentId: equipmentId,
        pumpStatus: pumpStatus
      };

      await axios.post('equipment/UpdatePumpStatus', requestData).then((response) => {
        if (response && response.data && response.data.Success) {
          showPumpLeftDepotPopup.value = false;
          emit('forceResetFilters');
          inst.proxy.setExpantFlag(false);
        }
      });
    };

    return {
      warehouses,
      currentWarehouseId,
      showWarning,
      pumpLendingSuccess,
      isPumpReturn,
      isPumpLeftDepot,
      showPumpLeftDepotPopup,
      setPumpLeftDepotPopup,
      pumpUseReason,
      setPumpUseReason,
      savePumpUseReason,
      updatePumpStatus,
      ...mapActions('patient', ['setActivePatient']),
      ...mapActions('pumpOverview', ['getWarehouseList', 'lendoutPump', 'pumpReturn', 'updateCurrentWarehouseId']),
      ...mapMutations({
        setWarehouses: 'pumpOverview/setWarehouses',
        setIsPumpReturn: 'pumpOverview/setIsPumpReturn',
        setShowWarning: 'pumpOverview/setShowWarning',
        setPumpLendingSuccess: 'pumpOverview/setPumpLendingSuccess'
      })
    };
  },
  data() {
    const { validate } = useForm();

    return {
      validate,
      isExpanded: false,
      beforeExpanded: false,
      isTransitioning: false,
      rowHeight: 'auto',
      rowHeightCollapsed: 'auto',
      overviewPage: false,
      pumpAssignmentPage: false,
      isPumpHover: false,
      pumpSelected: false,
      currentPumpId: '',
      currentSerialNumber: '',
      currentProductId: '',
      isPumpLending: false,
      lendingPostalCode: '',
      postCodeRule: {
        required: true
      },
      postcodeError: false,
      postCodeErrorMessage: 'Ingevoerde postcode is incorrect of bij ons niet bekend.'
    };
  },
  computed: {
    computedPumpDesc() {
      return this.data.equipmentID
        ? this.data.pumpDesc
        : this.data.pumpDesc.substring(this.data.pumpDesc.indexOf('-') + 1);
    }
  },
  created() {
    this.isPumpLending = false;
    if (router.currentRoute.value.name === 'pompenoverzicht') {
      this.overviewPage = true;
    }
    if (router.currentRoute.value.name === 'pumpassignment') {
      this.pumpAssignmentPage = true;
    }
  },
  methods: {
    setExpantFlag(flag) {
      this.isExpanded = flag;
    },
    toggle() {
      this.isExpanded = !this.isExpanded;
      if (this.pumpAssignmentPage) {
        this.isExpanded = false;
        if (this.data.equipmentID) {
          let radioButton = document.getElementById('rdb' + this.data.equipmentID);
          radioButton.checked = true;
          this.currentProductId = 0;
        } else {
          let radioButton = document.getElementById('rdb' + this.data.pumpDesc.split('-')[0]);
          radioButton.checked = true;
          this.currentProductId = this.data.pumpDesc.split('-')[0];
        }
        this.pumpSelected = true;
        this.currentPumpId = this.data.equipmentID;
      } else {
        this.pumpSelected = false;
      }
    },
    getContentCss() {
      if (this.pumpAssignmentPage) {
        this.isPumpHover = !this.isPumpHover;
      }
    },
    toPatientDashboard() {
      this.setActivePatient(this.data.patientId).then(() => {
        router.push('/patientdashboard');
      });
    },
    imageLoadError() {
      console.warn('Image without product');
    },
    getStatusColor(equipmentStatus) {
      switch (equipmentStatus) {
        case 'Allocated':
          return 'pumpOverview-row__cell__dynamicField__unavailable';
        case 'OutOfDepot':
          return 'pumpOverview-row__cell__dynamicField__unavailable';
        case 'Available':
          return 'pumpOverview-row__cell__dynamicField__available';
        case 'Naar Mediq':
          return 'pumpOverview-row__cell__dynamicField__unavailable';
        case 'ToMediq':
          return 'pumpOverview-row__cell__dynamicField__unavailable';
        case 'Lend':
          return this.userWarehouseId === this.data.lendoutWarehouseId
            ? 'pumpOverview-row__cell__dynamicField__available'
            : 'pumpOverview-row__cell__dynamicField__unavailable';
        case 'LendAndAssigned':
          return 'pumpOverview-row__cell__dynamicField__unavailable';
        case '':
          return 'pumpOverview-row__cell__dynamicField__unknown';
        default:
          return 'pumpOverview-row__cell__dynamicField__nocolor';
      }
    },
    getStatusColorForDaysLeftForMaintenance(daysLeftForMaintenance) {
      if (daysLeftForMaintenance >= 30) return 'pumpOverview-row__cell__dynamicField__available';

      if (daysLeftForMaintenance < 30 && daysLeftForMaintenance >= 14)
        return 'pumpOverview-row__cell__dynamicField__unknown';

      if (daysLeftForMaintenance < 14) return 'pumpOverview-row__cell__dynamicField__unavailable';

      return 'pumpOverview-row__cell__dynamicField__nocolor';
    },
    getStatusField(equipmentStatus) {
      switch (equipmentStatus) {
        case 'Allocated':
          return 'Bij patiënt';
        case 'Available':
          return 'In depot';
        case 'OutOfDepot':
          return 'Inzet buiten depot';
        case 'Lend':
          return this.userWarehouseId === this.data.lendoutWarehouseId ? 'In depot, geleend' : 'Uitgeleend';
        case 'LendAndAssigned':
          return this.userWarehouseId === this.data.lendoutWarehouseId
            ? 'Bij patient, geleend'
            : 'Uitgeleend en bij patient';
        case '':
          return 'Unknown';
        default:
          return equipmentStatus;
      }
    },
    pumpLending() {
      this.isPumpLending = true;
    },
    closeModal() {
      this.setWarehouses([]);
      this.setIsPumpReturn(false);
      this.setShowWarning(false);
      this.isPumpLending = false;
      this.postcodeError = false;
      this.showPumpLeftDepotPopup = false;
    },
    closeSucessModal() {
      this.setPumpLendingSuccess(false);
      this.setWarehouses([]);
      this.setShowWarning(false);
      this.isPumpLending = false;
      this.postcodeError = false;
      this.$router.go();
    },
    selectWarehouse(e) {
      e.stopPropagation();
      let id = parseInt(e.currentTarget.value, 10);
      this.updateCurrentWarehouseId(id);
    },
    showPumpReturnPopup() {
      this.setIsPumpReturn(true);
    },
    getWarehouseListData() {
      this.validate().then((result) => {
        if (result.valid) {
          this.getWarehouseList(this.lendingPostalCode);
        }
      });
    }
  }
};
</script>

<style lang="css">
.pumpOverview-row .pumpOverview-row__selectDept .form-group label {
  padding-left: 10px;
}
.pumpOverview-row .pumpOverview-row__selectDept .form-group--hasvalue label {
  display: none;
}
.pumpOverview-row .form-group input {
  line-height: 1.5rem;
  color: #666;
  padding-left: 10px;
  border: 1px solid;
  border-color: #999;
  border-radius: 3px;
  transition: opacity 0.2s ease-in-out;
  box-sizing: border-box;
  margin-right: 0;
  height: 49px;
}
</style>
<style lang="scss" scoped>
.pumpOverview-row {
  background-color: $table-row-background;
  border: $table-row-border;
  transition: $search-transition;
  &__cell {
    padding: $table-row-license-cell-padding;
    @mixin list {
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    &__desc {
      @include list;
      color: $teal-darkest;
      font-weight: bold;
    }
    &__serialno {
      @include list;
    }
    &__textbox {
      width: 200px;
    }
    &__img {
      @include list;
      max-height: 75px;
      margin-left: 5px;
    }
    &__rdb {
      margin-top: 34px;
      margin-left: 20px;
      margin-right: -10px;
    }
    &__dynamicField {
      @include list;
      width: 180px;
      .material-design-icon {
        display: inline-block;
        padding-right: 5px;
        vertical-align: middle;
        :deep(svg) {
          width: 15px;
          height: 15px;
        }
      }
      &__available {
        .material-design-icon {
          fill: $cyan-darker;
        }
      }
      &__unavailable {
        .material-design-icon {
          fill: $red;
        }
      }
      &__unknown {
        .material-design-icon {
          fill: $orange;
        }
      }
      &__nocolor {
        .material-design-icon {
          fill: transparent;
        }
      }
    }
    &__prescriber {
      color: $table-row-license-cell-prescriber-color;
      font-size: $table-row-license-cell-prescriber-font-size;
      line-height: $table-row-license-cell-prescriber-line-height;
      margin-left: 5px;
      margin-top: 0px;
      &__author {
        font-weight: $table-row-license-cell-prescriber-font-weight;
      }
    }
    > span > .material-design-icon {
      display: flex;
      justify-content: center;
      :deep(svg) {
        display: block;
      }
    }
  }
}
</style>
